import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useRealtimeFrame } from '../../shared/api/realtime';

const QUIET_MS = 3_000;

/** Counts on the list move fast (a flow's 24h Runs/Done/Failed); `flow_run.updated` is the
 * signal to refetch, not the new value — the row is re-read from `GET /v1/flows` (§3). */
export const useFlowsLiveUpdate = (): void => {
  const queryClient = useQueryClient();
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const refresh = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      void queryClient.invalidateQueries({ queryKey: ['flows'] });
    }, QUIET_MS);
  };

  useRealtimeFrame('flow_run.updated', refresh);
  useRealtimeFrame('flow_copy.skipped', refresh);

  useEffect(() => () => clearTimeout(timer.current), []);
};
